/**
 * jsonp
 *
 * Created by samuel on 11/11/2022.
 *
 */

export const jsonp = (url, params, cb) => {
	return new Promise((resolve, reject) => {
		let script = document.createElement('script');
		let _failCheckTimer = null,
			_done = false;
		params = { ...params, callback: cb };
		const arr = [];
		Object.keys(params).map((key) => {
			if (params[key]) {
				arr.push(`${key}=${encodeURIComponent(params[key])}`);
			}
		});
		if (url.match(/\?/)) {
			url += '&';
		} else {
			url += '?';
		}
		script.src = `${url}${arr.join('&')}`;

		script.onerror = () => {
			window[cb](null);
		};
		script.onload = script.onreadystatechange = () => {
			if (script && (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete')) {
				clearTimeout(_failCheckTimer);
				_failCheckTimer = setTimeout(() => {
					console.log('in!!!');
					if (!_done) {
						window[cb](null);
					}
				}, 1000);
			}
		};

		try {
			document.body.appendChild(script);
		} catch (e) {
			window[cb](null);
		}

		window[cb] = (data) => {
			clearTimeout(_failCheckTimer);
			_done = true;
			resolve(data);
			script.onload = null;
			script.onreadystatechange = null;
			script.onerror = null;
			script.parentNode.removeChild(script);
			script = null;
			delete window[cb];
		};
	});
};
